import React from 'react';
import { Sparkles, MessageSquare, LogIn } from 'lucide-react';
import { Link } from 'react-router-dom';
import { WHATSAPP_MESSAGE_URL } from '../constants';

export const FinalCTASection = () => {
  return (
    <section className="py-20 bg-slate-50 dark:bg-slate-950 border-t border-slate-200/60 dark:border-slate-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-indigo-900 via-violet-950 to-slate-950 rounded-[3rem] p-10 sm:p-16 text-center text-white relative overflow-hidden shadow-2xl border border-indigo-800/40">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-indigo-500/20 blur-[140px] rounded-full pointer-events-none" />

          <div className="relative z-10 max-w-3xl mx-auto space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 text-indigo-200 text-[10px] font-black uppercase tracking-widest backdrop-blur-md">
              <Sparkles size={14} className="text-amber-400" />
              Asesoría Personalizada
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black tracking-tight leading-tight">
              ¿Quieres conocer PastoreApp para tu iglesia?
            </h2>

            <p className="text-slate-300 text-base sm:text-lg font-medium leading-relaxed max-w-2xl mx-auto">
              Escríbenos y descubre cómo puede ayudar a organizar tu comunidad, formación, liderazgo y finanzas.
            </p>

            <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={WHATSAPP_MESSAGE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto px-8 py-4 bg-emerald-600 hover:bg-emerald-700 text-white font-black text-xs uppercase tracking-widest rounded-2xl flex items-center justify-center gap-3 shadow-xl active:scale-95 transition-all"
              >
                <MessageSquare size={18} />
                <span>Quiero conocer PastoreApp</span>
              </a>
              <Link
                to="/login"
                className="w-full sm:w-auto px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-black text-xs uppercase tracking-widest rounded-2xl flex items-center justify-center border border-white/20 transition-all gap-2"
              >
                <LogIn size={16} />
                <span>Iniciar sesión</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
